// extracted by mini-css-extract-plugin
module.exports = {"popup":"Reply_popup__2JoiR","popupInner":"Reply_popupInner__2wG9x","cancelButton":"Reply_cancelButton__2xmcj","popupcontent":"Reply_popupcontent__vpPN3"};